import { FC } from 'react';
import { Header } from '@tanstack/react-table';
import { HeaderCell } from './HeaderCell';
import { useTableStoreValue } from '../TableContext';

export const TableHead: FC = () => {
  const [table] = useTableStoreValue('table');
  const [hideLeftStickyShadow] = useTableStoreValue('hideLeftStickyShadow');
  const [hideRightStickyShadow] = useTableStoreValue('hideRightStickyShadow');

  const classNames = [];

  if (hideLeftStickyShadow) {
    classNames.push('hide-left-shadow');
  }

  if (hideRightStickyShadow) {
    classNames.push('hide-right-shadow');
  }

  return (
    <thead className={classNames.join(' ')}>
      {table.getHeaderGroups().map((headerGroup) => (
        <TableHeaderRow key={headerGroup.id} headers={headerGroup.headers} />
      ))}
    </thead>
  );
};

interface TableHeaderRowProps {
  headers: Header<any, any>[];
}

const TableHeaderRow: FC<TableHeaderRowProps> = (props) => {
  const { headers } = props;

  return (
    <tr>
      {headers.map((header, idx) => (
        <HeaderCell key={`${header.id}-header-${idx}`} header={header} />
      ))}
    </tr>
  );
};
